var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkrillLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "568px",
    height: "205px",
    viewBox: "0 0 568 205",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.58454,
    x2: 331.91,
    y1: 175.33,
    y2: 175.33,
    gradientTransform: "scale(1.7108 .58454)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#872166",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F2455",
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m451.7 24.7 47.2-8.4v181.1h-47.2zm68.9 0v172.6h47.2v-181zm-136 172.6h47.2v-132.4h-47.2zm-311.9-113.7c-6-0.4-19.8-1.3-19.8-13.7 0-15 19.9-15 27.3-15 13.1 0 30.1 3.9 42.2 7.5 0 0 6.8 2.4 12.5 4.8l0.5 0.1v-41l-0.7-0.2c-14.3-5-30.9-9.8-61.8-9.8-53.2 0-72 31-72 57.5 0 15.3 6.6 51.3 67.5 55.5 5.2 0.3 18.9 1.1 18.9 14 0 10.6-11.2 16.9-30.1 16.9-20.7 0-40.7-5.3-52.9-10.3v42.3c18.2 4.8 38.8 7.2 62.9 7.2 52 0 75.3-29.3 75.3-58.4 0-33-26-54.4-69.8-57.4zm285.3-20.6c-43.6 1.4-65.7 21-65.7 59.9v74.5h47.6v-60.8c0-23.3 3-33.3 30.7-34.2v-38.8c-4.8-0.9-12.6-0.6-12.6-0.6zm-128 1.8c-1 2.6-8.6 24-26.9 46.1v-94.6l-48.7 9.6v171.4h48.7v-53c14.1 21.2 21.1 53 21.1 53h58.3c-5.8-24-31-68.2-31-68.2 22.6-28.7 32.6-59.3 34.2-64.4h-55.7zm178.1-12.6c12.8 0 23.3-10.4 23.3-23.2s-10.4-23.3-23.3-23.3c-12.8 0-23.2 10.4-23.2 23.3 0 12.8 10.4 23.2 23.2 23.2z",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkrillLogo);
export default __webpack_public_path__ + "static/media/Skrill_logo.0cbe068ce3557cfd55b4087e6f89ea85.svg";
export { ForwardRef as ReactComponent };